<template lang="html">
  <div id="results-page">

    <section class="breadcrumb-section">
      <div class="container med-container px-lg-0">
        <span>Productos</span>
        <span class="line">/</span>
        <span>Sets</span>
      </div>
    </section>

    <section class="container med-container products-section">
      <div class="row align-items-start">

        <!-- Mobile filters -->
         <div class="col-12 col-filters-mobile">
          <div class="bg-filter-mv" v-if="showFilters == true" @click="showFilters = false"></div>
          <a class="btn-filters" @click="showFilters = !showFilters">
            <i class="fas fa-filter"></i><span>Ver filtros</span>
          </a>
        </div>

        <div class="col-lg col-filters" v-bind:class="{ 'show-filters': showFilters == true }">
          <h4 class="_title">
            <span>Filtros de Búsqueda</span>
            <a class="btn-hide" @click="showFilters = false"><i class="fas fa-chevron-left"></i></a>
          </h4>

          <b-form class="filters-container" @submit="onSubmitFilters">
            <div class="box-filters">
              <a class="btn-action"><i class="sy">-</i> Tipos de sets</a>

              <b-form-group class="box-filters-group" v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                  v-model="filtersForm.brands"
                  :aria-describedby="ariaDescribedby"
                  name="flavour-2">
                  <b-form-checkbox :value="br.id" v-for="(br,indx) in brandsOpcs" :key="'bra'+indx">{{br.name}}</b-form-checkbox>

                </b-form-checkbox-group>
              </b-form-group>
            </div>

            <div class="box-filters">
              <a class="btn-action"><i class="sy">-</i> Ocasiones</a>

              <b-form-group class="box-filters-group" v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                  v-model="filtersForm.occasions"
                  :aria-describedby="ariaDescribedby"
                  name="flavour-2">
                  <b-form-checkbox :value="oc.id" v-for="(oc,ocInx) in occasionsOpcs" :key="'ocInx'+ocInx">{{oc.name}}</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </div>

            <div class="box-filters">
              <a class="btn-action"><i class="sy">-</i> Precio</a>

              <div class="box-filters-group">
                <b-form-select class="c-filter-select" v-model="filtersForm.price">
                  <b-form-select-option :value="null">Cualquiera</b-form-select-option>
                  <b-form-select-option :value="800">$1,000 o más</b-form-select-option>
                  <b-form-select-option :value="1499">$3,000 o más</b-form-select-option>
                  <b-form-select-option :value="999999999999999999">$4,500 o más</b-form-select-option>
                </b-form-select>
              </div>
            </div>
          </b-form>
        </div>
        <!--  -->

        <!-- Resultados en columnas -->
        <div class="col-lg col-products">
          <div class="row sample-products-wrapper" v-if="!isLoading">
            <div class="col-12 col-s-title px-lg-2 mb-2">
              <h2 class="title-s1">Sets</h2>
            </div>

            <div class="col-md-6 col-xl-4 sample-product shad-prod" v-for="(product, pInx) in products" :key="'pInx-'+pInx">
              <a class="outlined-box">
                <router-link class="fake-link" :to="'/sets/'+$root._converToURL(product.name, product.id)"></router-link>

                <div class="box-image">
                  <div class="out-of-stock" v-if="product.stock < 1">Agotado</div>

                  <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+product.imageUrl+')' }">
                    <img src="public/images/pages/sets/product.png" >
                  </div>
                </div>

                <div class="box-shot-descr">
                  <h6 class="brand">{{ product.sku }}</h6>
                  <h6 class="name">{{ product.name }}</h6>
                  <div class="b-type">
                    <div class="type s1">SET DE 3 PIEZAS</div>
                  </div>
                  <!-- <h6 class="brand">{{ product.brand }}</h6> -->
                  <!-- <h6 class="price discount"><span>$ {{ product.price }}</span></h6> -->
                  <h6 class="price">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} USD</h6>
                </div>

                <cart-component :product="product"></cart-component>
              </a>
            </div>

            <div class="col-12 col-pagination">
              <b-pagination-nav :link-gen="linkGen" :number-of-pages="pagination.total" use-router></b-pagination-nav>
            </div>
          </div>

          <div class="row">
            <div class="col-12 text-center" v-if="!products.length && !isLoading">
              <h5>No se encontraron resultados</h5>
            </div>

            <div class="col-12" v-if="isLoading">
              <LoadingComponent></LoadingComponent>
            </div>
          </div>
        </div>
        <!--  -->

      </div>

    </section>

  </div>
</template>

<script>
import LoadingComponent from '../shared/loading-component.vue';
export default {
  components: {
    LoadingComponent
  },

  data(){
    return{
      isLoading: true,
      showFilters: false,

      filtersForm: {
        brands:[],
        occasions:[],
        price:null,
      },

      products: [
        {
          "id": 1,
          "sku": "63423",
          "name": "SET DE COJINES Y ROSAS",
          "price": "890.00",
          "stock": 5,
          "imageUrl": "public/images/pages/sets/product-1.jpg"
        },
        {
          "id": 2,
          "sku": "59227",
          "name": "SET CON COLCHONES, FLORES Y BIBLIA",
          "price": "1290.00",
          "stock": 15,
          "imageUrl": "public/images/pages/sets/product-2.jpg",
        },
        {
          "id": 3,
          "sku": "66720",
          "name": "SET DE BIBLIA Y DOS ALMOHADAS",
          "price": "780.00",
          "stock": 9,
          "imageUrl": "public/images/pages/sets/product-3.jpg"
        },
        {
          "id": 4,
          "sku": "59223",
          "name": "SET DE 7 PIEZAS CON ALMOHADAS, FLORES Y BIBLIA",
          "price": "999.00",
          "stock": 6,
          "imageUrl": "public/images/pages/sets/product-4.jpg"
        },
        {
          "id": 5,
          "sku": "43512",
          "name": "SETS DE COJINES, BIBLIA Y ROSAS",
          "price": "1500.20",
          "stock": 9,
          "imageUrl": "public/images/pages/sets/product-5.jpg"
        },
        {
          "id": 6,
          "sku": "63423",
          "name": "SET DE COJINES, ALMOHADAS, BIBLIA Y ROSAS",
          "price": "980.00",
          "stock": 89,
          "imageUrl": "public/images/pages/sets/product-6.jpg"
        },
      ],

      category: {
        name: 'Promociones'
      },
      category_id:null,
      brandsOpcs:[
        { id: 1, name: 'De 3 piezas' },
        { id: 2, name: 'De 6 piezas' },
        { id: 3, name: 'De 7 piezas' },
      ],
      occasionsOpcs:[
        { id: 1, name: 'XV Años' },
        { id: 2, name: '16 Años' },
        { id: 3, name: 'Bodas' },
        { id: 4, name: 'Bautizo' },
        { id: 5, name: 'Confirmación' },
        { id: 6, name: '25 Aniversario' },
        { id: 7, name: '50 Aniversario' },
        { id: 8, name: 'Comunión' },
        { id: 9, name: 'Presentaciones' },
      ],

      // == Pagination ==
      pagination:{
        currentpage: 1,
        total: 1,
        total_products: 16,
        number: 10
      },
      // == ==
    }
  },

  watch: {
    "$route.params.id" : function(v){
      this.category_id = this.$root._getURLID(this.$route.params.id);
      if(this.category_id){
          this.products=[];
          this.getProductsCategory(this.category_id);
      }
    },
    "filtersForm.brands" : function(v){
        // this.getProductsCategory(this.category_id);
    },
    "filtersForm.subcategories" : function(v){
        this.getProductsCategory(this.category_id);
    },
    "filtersForm.price" : function(v){
        this.getProductsCategory(this.category_id);
    },
  },

  methods: {
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`
    },

    onSubmitFilters(evt) {
        evt.preventDefault();

    },

    getProductsCategory: function(category_id){
        this.isLoading = true;
        axios.post(tools.url('/api/products/category/'+category_id),this.filtersForm).then((response) =>{
            this.products = response.data.products;
            this.category = response.data.category;
            this.isLoading = false;
        }).catch((error)=>{
          console.log(error);
        });
    },
    getBrandsOpcs(){
      axios.get(tools.url('/api/brandsOpcs/'+this.category_id+'/c')).then((response)=>{
        this.brandsOpcs = response.data;
      }).catch((error)=>{
        console.log(error);
      });
    },
    getSubcategoriesOpcs(){
      axios.get(tools.url('/api/subcategoriesOpcs/'+this.category_id+'/c')).then((response)=>{
        this.subcategoriesOpcs = response.data;
      }).catch((error)=>{
        console.log(error);
      });
    },
  },

  mounted(){

    setTimeout( ()=>{ this.isLoading = false; }, 2000); // ejemplo de "loading" despues de cargar

    if(this.$route.params.id){
       this.category_id = this.$root._getURLID(this.$route.params.id);
       this.getProductsCategory(this.category_id);
       this.getBrandsOpcs();
      this.getSubcategoriesOpcs();
    }
  },
}
</script>
